import { get, post, put, patch, destroy } from "./base";

const OrdersServ = {
  index: (params) => get("/Orders", { params }),
  single: (id) => get(`/Orders/${id}`),
  addToCart: (payload) => post("/Orders/cart/add", payload),
  placeOrder: (payload) => post("/Orders/place-order", payload),
  cancelPending: (payload) => post("/Orders/cancel-pending", payload),
  getMyOrders: (params) => get("/Orders/my-orders", { params }),
  getSellerOrders: (shopId) => get(`/Orders/seller/shop-orders/${shopId}`),
  getSellerAllOrders: (params) => get("/Orders/seller/all-orders", { params }),
  getAdminAllOrders: (params) => get("/Orders/admin/all-orders", { params }),
  update: (id, payload) => put(`/Orders/${id}`, payload),
  updateStatus: (id, status, comment) => put(`/Orders/${id}/status`, { status, comment }),
  cancelOrder: (id, reason) => put(`/Orders/${id}/cancel`, { reason }),
  rescheduleOrder: (id, payload) => put(`/Orders/${id}/reschedule`, payload),
  remove: (id) => destroy(`/Orders/${id}`),

  // Return Requests
  getMyReturns: () => get("/Orders/returns/my-returns"),
  submitReturnRequest: (payload) => post("/Orders/returns/submit", payload),
  adminReviewReturn: (id, status, adminComment) => put(`/Orders/returns/admin/${id}/review`, { status, adminComment }),
  adminProcessRefund: (id) => put(`/Orders/returns/admin/${id}/refund`),
  getAllReturns: (params) => get("/Orders/returns/all", { params }),
  getSellerReturns: () => get("/Orders/returns/seller/all"),
  updateReturnStatus: (id, status, sellerComment) => {
    if (status === 'approved' || status === 'RETURN_PICKUP_PENDING') {
      return put(`/Orders/returns/seller/${id}/review`, { status: 'RETURN_PICKUP_PENDING', sellerComment });
    }
    if (status === 'rejected' || status === 'RETURN_REJECTED_BY_SELLER') {
      return put(`/Orders/returns/seller/${id}/review`, { status: 'RETURN_REJECTED_BY_SELLER', sellerComment });
    }
    if (status === 'refund_completed' || status === 'RETURN_COMPLETED' || status === 'waiting_for_admin_refund') {
      return put(`/Orders/returns/seller/${id}/verify-receipt`, { verified: true, sellerNote: sellerComment });
    }
    // Fallback to legacy/admin route
    return put(`/Orders/returns/${id}/status`, { status, sellerComment });
  },

  // Delivery Time Change
  requestDeliveryTimeChange: (id, payload) => put(`/Orders/${id}/request-time-change`, payload),
  respondToDeliveryTimeChange: (id, response) => put(`/Orders/${id}/respond-time-change`, { response }),

  // Seller/Admin Actions
  sellerReschedule: (id, payload) => patch ? patch(`/Orders/${id}/reschedule`, payload) : put(`/Orders/${id}/reschedule`, payload),
  sellerRequestUpdate: (id, payload) => patch ? patch(`/Orders/${id}/request-update`, payload) : put(`/Orders/${id}/request-update`, payload),
  sellerCancel: (id, payload) => patch ? patch(`/Orders/${id}/cancel-by-seller`, payload) : put(`/Orders/${id}/cancel-by-seller`, payload),
  confirmReplacedOrder: (id) => patch(`/Orders/${id}/confirm-replaced`),
  
  // Buyer Actions
  buyerRespondToUpdate: (id, response, additionalRemovals = [], rejectedIssueProducts = [], addedProducts = []) => 
    patch(`/Orders/${id}/respond-to-update`, { response, additionalRemovals, rejectedIssueProducts, addedProducts }),

  // Admin & Seller Direct Actions
  confirmOrder: (id) => put(`/Orders/${id}/confirm`),
  markPacked: (id) => put(`/Orders/${id}/mark-packed`),

  // Admin Override — Force status (hits POST /Orders/admin/:id/force-status)
  adminForceStatus: (id, status, comment) => post(`/Orders/admin/${id}/force-status`, { status, comment }),

  // Reviews and Feedback
  getReviewEligibility: (id) => get(`/Orders/${id}/review-eligibility`),
  submitDeliveryShopReview: (id, payload) => post(`/Orders/${id}/rate-delivery-shop`, payload),
  submitProductFeedback: (payload) => post(`/feedback/product`, payload),
};

export default OrdersServ;
